import * as React from 'react';
import type { FC } from 'react';
import type { Locales } from 'app/helpers/createLocalesContext';
import { translation } from 'app/helpers/createLocalesContext';
import type { QuickSignupFormProps, Values, ChangeValues } from './types';
import WalletIcon from './images/icon_wallet.svg';

const Currency: FC<{
  values: Values;
  changeValues: ChangeValues;
  currencies: QuickSignupFormProps['currencies'];
  locales: Locales;
}> = ({ values, changeValues, currencies, locales }) => (
  <div className="player_currency-wrap">
    <div className="currencies-title rs-text-align_center">{translation(locales, 'currency.label')}</div>
    <div className="input player_currency player_currency__select xo-form_select-iconfull">
      <div className="xo-form_select-wrap">
        <select
          name="player[currency]"
          id="player_currency"
          className="xo-form_select"
          onChange={(v) => changeValues({ currency: v.target.value })}
          value={values.currency}
        >
          {currencies.map(([code, name]) => (
            <option value={code} key={code}>
              {`${name} ${code}`}
            </option>
          ))}
        </select>
        <label htmlFor="player_currency" className="xo-form_input-label">
          <span className="xo-form_label-placeholder">{translation(locales, 'currency.label')}</span>
          <span className="xo-form_input-image">
            <img src={WalletIcon} alt="icon" />
          </span>
        </label>
      </div>
      <div className="hints">
        <span className="hint">{translation(locales, 'currency.hint')}</span>
      </div>
    </div>
  </div>
);

export default Currency;
